// Export ToastTitle (same as AlertTitle)
import {
  AlertTitle,
  type AlertTitleProps,
} from 'src/components/AlertTitle/AlertTitle';
export const ToastTitle = AlertTitle;
export type ToastTitleProps = AlertTitleProps;
